module.exports = __webpack_public_path__ + "img/incident.745bde67.gif";